import React, { FunctionComponent } from 'react';

export type ButtonRightArrowProps = {
  className?: string;
};

export const ButtonRightArrow: FunctionComponent<ButtonRightArrowProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23861 19.5C8.98819 19.5 8.73778 19.4048 8.54735 19.2131C8.1652 18.8309 8.1652 18.2127 8.54735 17.8305L14.3774 12.0005L8.54735 6.17043C8.1652 5.78829 8.1652 5.16876 8.54735 4.78661C8.9295 4.40446 9.54772 4.40446 9.92987 4.78661L16.4525 11.3092C16.6364 11.4918 16.7394 11.7409 16.7394 12.0005C16.7394 12.26 16.6364 12.5092 16.4525 12.6917L9.92987 19.2131C9.73945 19.4048 9.48903 19.5 9.23861 19.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
